import { Pagination } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { usePagination } from '../hooks/usePagination';

const StyledPagination = styled(Pagination)`
  margin-top: 16px;
  padding-top: 16px;
  text-align: right;
  flex-shrink: 0;

  @media (max-width: 768px) {
    padding-bottom: 16px;
  }
`;

interface BottomPaginationProps {
  total: number;
}

export const BottomPagination: React.FC<BottomPaginationProps> = ({ total }) => {
  const { page, pageSize, setPage } = usePagination();

  return (
    <StyledPagination
      current={page}
      pageSize={pageSize}
      total={total}
      showSizeChanger
      onChange={setPage}
    />
  );
};
